import * as yup from 'yup';

const project = yup.object({
  id: yup.number().required(),
  name: yup.string().required(),
  value: yup
    .number()
    .nullable()
    .transform((value: string | number) => {
      if (typeof value !== 'number' || Number.isNaN(Number(value))) return null;

      return Number(value);
    }),
});

const metric = yup.object({
  id: yup.number().required(),
  name: yup.string().required(),
  description: yup.string(),
  projects: yup.array().of(project).required(),
});

export const editMetricsSchema = yup.object({
  items: yup.array().of(metric),
});
